import { render, staticRenderFns } from "./UserGroupsPage.vue?vue&type=template&id=762fd223"
import script from "./UserGroupsPage.vue?vue&type=script&lang=js"
export * from "./UserGroupsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('762fd223')) {
      api.createRecord('762fd223', component.options)
    } else {
      api.reload('762fd223', component.options)
    }
    module.hot.accept("./UserGroupsPage.vue?vue&type=template&id=762fd223", function () {
      api.rerender('762fd223', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/UserGroupsPage.vue"
export default component.exports